const svgCache = new Map<string, SVGElement | Error | undefined>()

export default svgCache
